import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { JobsPage } from '@/features/jobs/jobs-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Jobs d'un projet : le projet est dans l'URL, plus jamais « le premier du tenant ». */
export const Route = createFileRoute('/$tenant/projects/$projectId/jobs/')({ component: ProjectJobsRoute });

function ProjectJobsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="jobs"
      crumbs={[{ label: t('nav.items.jobs') }]}
    >
      <JobsPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
